import React, {
	useState,
	useEffect
} from 'react'
import classnames 	from 'classnames'
import { connect } 	from 'react-redux'
import {
	TransitionGroup,
	CSSTransition
} from 'react-transition-group'
import {
	Link
} from 'gatsby'
import {
	isFunction
} from 'lodash'

import ARYImage 	from '../ary-image'
import Icon 		from '../icon'
import InlineImage 	from '../inline-image'
import {
	TextBlock
} from '../text-block'

import breakpoints 	from '../../lib/constants/breakpoints.json'
import {
	formatLink
} from '../../lib/formatLink'
import withLinks from '../with-links'

const HeaderMenuLink = (props) => {
	const {
		link,
		title,
		showArrow,
		onClick
	} = props

	return <Link
		to={ formatLink(link) }
		onClick={ onClick && isFunction(onClick) ? onClick : null }
		>
		<span>{ title }</span>
		{ showArrow ? <span className="headerMenu-link-dropdown" /> : null }
	</Link>
}

export default connect(
	(state) => {
		const {
			ui
		} = state
	
		return {
			menuOpen: ui.menuOpen,
			headerHeight: ui.headerHeight,
			screenSize: ui.screenSize
		}
	}
)((props) => {
	const {
		links,
		menuOpen,
		headerHeight,
		screenSize
	} = props

	const [subNavOpen, setSubNavOpen] = useState(null)

	useEffect(() => {
		setSubNavOpen(null)
	}, [menuOpen])

	return <TransitionGroup>
		{ menuOpen ? <CSSTransition
			key={ menuOpen }
			classNames='headerMenu-'
			timeout={{
				enter: 900,
				exit: 600
			}}>
			<div
				className={ classnames('headerMenu') }
				style={{
					paddingTop: headerHeight,
					height: screenSize.height
				}}
				>
				<div className="headerMenu-content">
					<div className="headerMenu-links">
						{ links ? links.map((_link, _i) => {
							const _hasSubLinks = _link.subLinks && _link.subLinks.length > 0
							const _subNavActive = subNavOpen === _i

							return <div
								key={ _i }
								className={ classnames('headerMenu-link', {
									'headerMenu-link--hasSubLinks': _hasSubLinks,
									'headerMenu-link--hasSubLinks-open': _hasSubLinks && _subNavActive
								}) }
								>
								<HeaderMenuLink
									onClick={ _hasSubLinks ? (e) => {
										e.preventDefault()
										e.stopPropagation()

										setSubNavOpen(_subNavActive ? null : _i)
									} : null }
									showArrow={ _hasSubLinks }
									{ ..._link }
									/>
								{ _hasSubLinks ? <div className="headerMenu-subLinks">
										{ _link.subLinks.map((__link, __j) => {
											return <div
												key={ __j }
												className="headerMenu-link">
												<HeaderMenuLink
													{ ...__link }
													/>
											</div>
										}) }
									</div> : null }
							</div>
						}) : null }
					</div>
				</div>
			</div>
		</CSSTransition> : null }
	</TransitionGroup>
})